import React, { useState, useEffect } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";

const AddMake = () => {
  const [formData, setFormData] = useState({});
  const [productOptions, setProductOptions] = useState([]);
  const [subproductOptions, setSubproductOptions] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const [loading, setLoading] = useState(false);

 

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axiosInstance.post(
          "/product/ddlproduct",
          {
            orderBy: "product_id desc",
            page: 0,
            pageSize: 1000, // Adjust the page size as needed
           
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        const productList = response.data.data.data.map((product) => ({
          label: product.NAME,
          value: product.ID,
        }));

        setProductOptions(productList);
      } catch (error) {
        console.error("Error fetching product list:", error);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    // Fetch the list of subproducts based on the selected product
    const fetchSubproducts = async () => {
      if (!formData.productName) return;

      try {
        const response = await axiosInstance.post(
          "/subproduct/ddlsubproduct",
          {
            // product_id: formData.productName[0].value,
            product_id: formData.productName,
            orderBy: "subproduct_id desc",
            page: 0,
            pageSize: 1000, // Adjust the page size as needed
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        const subproductList = response.data.data.data.map((subproduct) => ({
          label: subproduct.NAME,
          value: subproduct.ID,
        }));

        setSubproductOptions(subproductList);
      } catch (error) {
        console.error("Error fetching subproduct list:", error);
      }
    };

    fetchSubproducts();
  }, [formData?.business_partner_id,formData?.productName]);

  const handleFormSubmit = async () => {
    // Validate form before submission
    const errors = {};
    let isValid = true;

    formConfig.forEach((field) => {
      if (field.required && !formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    console.log("fomrdata", formData);

    showCustomAlert({
      title: "Success",
      text: "Are you sure you want to add a record in Make.",
      confirmButtonText: "Make added successfully.",
      icon: "success",
      confirmButtonText: "OK",
      callback: async () => {
        try {
          setLoading(true)
          const payload = {
            product_id: formData.productName,
            subproduct_id: formData.subproductName,
            make_desc: formData.makedesc,
            make_name: formData.makeName,
            status: formData.status ==true ? 1 : 0,
          };

         

          const response = await axiosInstance.post("/make/create", payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          });

          console.log("API Response:", response.data);
          // Navigate to make management page after successful submission

          if (response.status === 200) {
            navigate("/admin/manage-product/make");
          }
        } catch (error) {
          console.error("Error submitting form:", error);

          const errorMessage = error.response?.data?.message;

          showErrorAlert({
            title: "Something went wrong",
            text:
              errorMessage ||
              "An error occurred while processing your request.",
            callback: () => {
              // Optional: code to execute after confirming the alert
              console.log("Error alert confirmed");
            },
          });
          // Handle error or display error message to user
        }
        finally{
          setLoading(false)
        }
      },
    });
  };

  const formConfig = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: { required: true },
          },
        ]
      : []),
    {
      name: "productName",
      label: "Product Name",
      type: "dropdown",
      required: true,
      options: productOptions,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "subproductName",
      label: "Subproduct Name",
      type: "dropdown",
      options: subproductOptions,
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "makeName",
      label: "Make Name",
      type: "text",
      placeholder: "Enter Make Name",
      required: true,
      validation: {
        required: true,
        pattern: /^[A-Za-z\s]*$/,
        message: "Only Alphabets Are Allowed*",
      },
      gridClass: "col-lg-4",
    },
    {
      name: "makedesc",
      label: "Description",
      placeholder: "Enter Make Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },

    {
      name: "status",
      label: "Status",
      type: "toggle",
      required: true,
      gridClass: "col-lg-4",
    
    },
  ];

  return (
    <>
     <div>
    {loading ? ( 
      <Loader />
    ) : (
      <><div
              className="backbutton mt-2 mb-2"
              onClick={() => navigate("/admin/manage-product/make")}
            >
              <img src={backicon} alt="back" />
              <span className="backbtntitle">Add Make</span>
            </div><div className="form-container">
                <span className="cust-det-title mt-2 mb-2">
                  Please Enter Make Details
                </span>
                <DynamicForm
                  formConfig={formConfig}
                  formData={formData}
                  setFormData={setFormData}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors} />
              </div><div className="btncontainer mt-3">
                <button onClick={handleFormSubmit} className="submit-btn">
                  Submit
                </button>
              </div></>
         )}
</div>
    </>
  );
};

export default AddMake;
